import {
  HardHat, Wrench, Hammer, Home, Building2, PlusSquare, Container,
  Leaf, Flame, Droplets, Lightbulb, Layers, Mountain, Zap, Shovel,
  Star, ThumbsUp, Award, ShieldCheck, Users, MapPin, Clock, BadgeCheck,
  Phone, Settings, Truck, PaintBucket,
} from "lucide-react";
import { siteConfig } from "../siteConfig";

// Full icon registry — add any Lucide icon here as needed.
// Keys match the string values used in siteConfig (brandIcon, service icon, etc.)
export const ICON_REGISTRY = {
  HardHat, Wrench, Hammer, Home, Building2, PlusSquare, Container,
  Leaf, Flame, Droplets, Lightbulb, Layers, Mountain, Zap, Shovel,
  Star, ThumbsUp, Award, ShieldCheck, Users, MapPin, Clock, BadgeCheck,
  Phone, Settings, Truck, PaintBucket,
};

// Resolved brand icon component — use this wherever the brand accent icon appears
export const BrandIcon = ICON_REGISTRY[siteConfig.brandIcon] ?? HardHat;

// Resolve any icon by name string, with a fallback
export const getIcon = (name, fallback = HardHat) =>
  ICON_REGISTRY[name] ?? fallback;
